interface ResultType {
  width: string
  height: string
}

/**
 * Function for getting image sizes from alt text of the image node
 */
export const getImageSizes = (altText: string | null): ResultType => {
  const matchedData = (altText || '{x}').match(/\{([^{}x]*)x([^{}]*)\}/)
  const width = matchedData?.[1] || ''
  const height = matchedData?.[2] || ''

  return {
    width,
    height,
  }
}
